export const getLocalStorage = (storageKey: string, objKey?: string) => {
  const storedValue = localStorage.getItem(formatKey(storageKey));
  const value = storedValue ? JSON.parse(storedValue) : undefined;

  return objKey ? value[objKey] : value;
};

export const setLocalStorage = <T>(
  storageKey: string,
  value: T,
  objKey?: string,
) => {
  const formattedKey = formatKey(storageKey);
  const storedValue = getLocalStorage(storageKey);
  const updatedValue = objKey ? { ...storedValue, [objKey]: value } : value;
  const jsonValue = JSON.stringify(updatedValue);

  localStorage.setItem(formattedKey, jsonValue);

  return jsonValue;
};

export function formatKey(key: string) {
  return `${import.meta.env.VITE_APP_NAME.toLowerCase()}|${key}`;
}
